import { Tab } from '../../common/domain/mappingAudit';

export const TABS_PATHS: Record<
  Tab.RATES_FIELD | Tab.RATES_FIXING | Tab.LEGAL_ENTITY,
  string
> = {
  [Tab.RATES_FIELD]: 'rates-field',
  [Tab.RATES_FIXING]: 'rates-fixing',
  [Tab.LEGAL_ENTITY]: 'legal-entity',
};
